import { useTranslation } from "react-i18next";
import React from "react";

export const CartEmptyMesg = () => {
  const { t } = useTranslation();
  return (
    <div className="top-[15.5rem] w-full py-8 text-center">
      <img
        className="mx-auto mb-4 h-12 w-12"
        src="../../assets/icons/cart-empty.svg"
        alt=""
      />
      <h2 className="text-base font-semibold leading-[1.25rem] text-[#5E6D77]">
        {t("Empty cart")}
      </h2>
    </div>
  );
};
